import OtherPlatformSvgPath from '@/../img/other-platforms-custom';
import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  background-color: #ffe7ba;
  border-radius: 6px;
`;
export function OtherPlatformSvg() {
  return (
    <Svg viewBox="-3 -2 30 30">
      <OtherPlatformSvgPath />
    </Svg>
  );
}
